import React from 'react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
interface ButtonCTAProps {
  text: string;
  subtext?: string;
  className?: string;
  showGuarantee?: boolean;
}
export function ButtonCTA({
  text,
  subtext,
  className = '',
  showGuarantee = false
}: ButtonCTAProps) {
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-1">
      <a href="https://bienestardigital.click/checkouts/cn/hWNBOcboJN6tOU1huEYNdJ9G/es-ar?_r=AQABR5vpoO_rsqWw0HzjMb-t0gH5D1fXMXsgxTcm5sE1_fQ&preview_theme_id=162381037657" className="group relative inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 sm:px-10 sm:py-5 text-lg sm:text-xl font-bold text-white transition-all duration-300 bg-terracotta-600 rounded-full hover:bg-terracotta-700 hover:shadow-[0_0_30px_rgba(200,121,101,0.4)] hover:-translate-y-1 overflow-hidden" data-id="element-2">
        <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-shimmer" data-id="element-3"></div>
        <span className="relative flex items-center gap-3 text-center" data-id="element-4">
          {text}{' '}
          <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover:translate-x-1 flex-shrink-0" data-id="element-5" />
        </span>
      </a>

      {subtext && <p className="mt-3 text-sm font-medium text-earth-500 text-center" data-id="element-6">
          {subtext}
        </p>}

      {showGuarantee && <div className="flex items-center gap-2 mt-3 text-xs text-earth-400" data-id="element-7">
          <ShieldCheck className="w-4 h-4 text-sage-500" data-id="element-8" />
          <span data-id="element-9">Garantía 7 días • Pago único y seguro • Acceso inmediato</span>
        </div>}
    </div>;
}